import Iter from 'core-js-pure/features/iterator';

/**
 * @template T
 * @param {Iterable<T>} it
 * @returns {IterableIterator<T>} ...
 */
export function from(it) {
	return Iter.from(it);
}

/**
 * @returns {IterableIterator<number>} ...
 */
export function enumerate() {
	function* gen() {
		let i = 0;
		while (true) {
			yield i;
			i += 1;
		}
	}

	return Iter.from(gen());
}

/**
 * **You need to consume the sub Iter before requesting the next one**
 * @template T
 * @param {number} chunkSize
 * @param {Iterable<T>} it
 * @returns {IterableIterator<IterableIterator<T>>} ...
 */
export function chunk(chunkSize, it) {
	const it2 = it[Symbol.iterator]();

	let done = false;
	function* subGen() {
		for(let i = 0; i < chunkSize; i += 1) {
			const res = it2.next();
			if (res.done) {
				done = true;
				break;
			}
			yield res.value;
		}
	}

	function* gen() {
		while (!done) {
			yield Iter.from(subGen());
		}
	}

	return Iter.from(gen());
}

/**
 * @template T1
 * @template T2
 * @param {Iterable<T1>} it1
 * @param {Iterable<T2>} it2
 * @returns {IterableIterator<T1 | T2>} ...
 */
export function zip(it1, it2) {
	const it12 = it1[Symbol.iterator]();
	const it22 = it2[Symbol.iterator]();

	function* gen() {
		while (true) {
			const res1 = it12.next();
			if (res1.done) {
				break;
			}
			yield res1.value;

			const res2 = it22.next();
			if (res2.done) {
				break;
			}
			yield res2.value;
		}
	}
	return Iter.from(gen());
}

/**
 * @template T1
 * @template T2
 * @param {Iterable<T1>} it1
 * @param {Iterable<T2>} it2
 * @returns {IterableIterator<T1 | T2>} ...
 */
export function chain(it1, it2) {
	const it12 = it1[Symbol.iterator]();
	const it22 = it2[Symbol.iterator]();

	function* gen() {
		while (true) {
			const res1 = it12.next();
			if (res1.done) {
				break;
			}
			yield res1.value;
		}

		while (true) {
			const res2 = it22.next();
			if (res2.done) {
				break;
			}
			yield res2.value;
		}
	}
	return Iter.from(gen());
}

/**
 * @template T
 * @template S
 * @param {S} separator
 * @param {Iterable<T>} it
 * @returns {IterableIterator<T | S>} ...
 */
export function join(separator, it) {
	const it2 = it[Symbol.iterator]();
	function* gen() {
		{
			const res = it2.next();
			if (res.done) {
				return;
			}
			yield res.value;
		}

		while (true) {
			const res = it2.next();
			if (res.done) {
				return;
			}
			yield separator;
			yield res.value;
		}
	}
	return Iter.from(gen());
}

/**
 * @template T
 * @param {T} value
 * @returns {IterableIterator<T>} ...
 */
export function cycle(value) {
	function* gen() {
		while (true) {
			yield value;
		}
	}
	return Iter.from(gen());
}

/**
 * @template T
 * @param {T} value
 * @returns {IterableIterator<T>} ...
 */
export function once(value) {
	function* gen() {
		yield value;
	}
	return Iter.from(gen());
}
